<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    bottom
    left
    offset-y>
    <v-btn
      slot="activator"
      icon>
      <v-icon>notifications</v-icon>
    </v-btn>

    <v-card>
      <v-list>
        <v-list-tile
          v-if="!notifications.length"
          avatar>
          <v-list-tile-content text-center>
            <v-list-tile-sub-title class="text-xs-center font-italic">{{ $t('noContent') }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <template v-for="notification in notifications">
        <v-divider :key="notification"/>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'NotificationBlock',
  data () {
    return {
      menu: false,
      notifications: []
    }
  },
  i18n: {
    messages: {
      en: {
        noContent: 'Empty'
      },
      tr: {
        noContent: 'Boş'
      },
      de: {
        noContent: 'Keine Nachrichten'
      },
      ru: {
        noContent: 'Пусто'
      }
    }
  }
}
</script>

<style scoped>

</style>
